<template>
  <b-container
    fluid
    class="col-5 border-secondary mx-auto border__div px-0 pt-0 pb-4 my-3"
    v-if="storico"
  >
    <div class="text-secondary rounded-top py-2 d-flex justify-content-around">
      <h5 class="d-block ml-auto mr-0 font-weight-bold">
        Storico {{ this.parametro }}
      </h5>
      <span
        class="px-1 text-center col-1 ml-auto mr-1 point font-weight-bold border border-secondary rounded close_span"
        title="chiudi"
        @click="remove"
        >x</span
      >
    </div>
    <!-- <span>{{ new Date() | moment("LLLL") }}</span> -->
    <br />
    <div class="pr-1">
      <div class="d-flex flex-column mx-auto overflow__box__s">
        <div
          v-for="(param, ind) in this.storico"
          :key="ind"
          class="my-1 d-flex justify-content-center mx-auto"
        >
          <span class="text-secondary text-capitalize col px-0">
            <strong>{{ param.record.valore }}</strong>
            {{ param.created_at | moment("LLLL") }}
          </span>
        </div>
      </div>
    </div>
    <p v-show="msg">Non hai ancora registrato alcun parametro</p>
  </b-container>
</template>
<script>
export default {
  name: "storico-parametro",
  props: ["parametro"],
  data() {
    return {
      param: this.parametro,
      storico: null,
      msg: false,
    };
  },
  methods: {
    fetchData() {
      var url = process.env.VUE_APP_VERSION + "rilevazione";
      this.$axios
        .get(url, {
          params: { esame: this.parametro },
        })
        .then((res) => {
          this.storico = res.data.data;
          // console.log(res.data.data);
          if (this.storico.length == 0) {
            this.msg = true;
          }
        })
        .catch(() => {
          //   this.$router.go();
          this.msg = true;
        });
    },
    remove() {
      this.$emit("remove-storico", this.parametro);
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {},
};
</script>
<style>
.close_span {
  height: 25px;
}
</style>
